import {inject, Injectable} from "@angular/core";
import Keycloak from "keycloak-js";
import {map, Observable, of} from "rxjs";
import {UiSettingsService} from "./ui-settings.service";

@Injectable({providedIn: 'root'})
export class ConfigWriteUserService {
    private readonly keycloak = inject(Keycloak);
    private readonly uiSettings = inject(UiSettingsService);

    readonly isAuthorized = this.keycloak.hasRealmRole('portal_config_write');

    isAllowedToEditApplicationSettings(applicationName: string | null | undefined): Observable<boolean> {
        if (!this.isAuthorized || !applicationName) {
            return of(false);
        }

        return this.uiSettings.editableApplicationSettings$.pipe(
            map(editableApplicationSettings => editableApplicationSettings.includes(applicationName))
        );
    }
}
